import { render, staticRenderFns } from "./depot.vue?vue&type=template&id=0463ff5c&scoped=true&"
import script from "./depot.vue?vue&type=script&lang=js&"
export * from "./depot.vue?vue&type=script&lang=js&"
import style0 from "./depot.vue?vue&type=style&index=0&id=0463ff5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0463ff5c",
  null
  
)

export default component.exports